import { Avatar, Colors, Icon, Pills } from '@amelio/ui-library';

import { RevieweeInformation } from './RevieweeInformation';

export interface MobileRevieweeCardProps {
    isSelfEvaluation: boolean;
    revieweeFullName: string;
    revieweeJobTitle: string;
    revieweeProfilePictureUrl: string;
    selfEvaluationPillLabel: string;
    reviewedColleaguePillLabel: string;
    revieweeCardBorderColor: string;
}

export const MobileRevieweeCard = ({
    isSelfEvaluation,
    revieweeFullName,
    revieweeJobTitle,
    revieweeProfilePictureUrl,
    selfEvaluationPillLabel,
    reviewedColleaguePillLabel,
    revieweeCardBorderColor,
}: MobileRevieweeCardProps) => {
    const pillLabel = isSelfEvaluation ? selfEvaluationPillLabel : reviewedColleaguePillLabel;

    return (
        <div
            className={'flex items-center gap-3 rounded-xl border bg-white/70 p-3'}
            style={{ borderColor: revieweeCardBorderColor }}
        >
            {isSelfEvaluation ? (
                <div
                    className={
                        'bg-primary-50 flex h-10 w-10 shrink-0 items-center justify-center rounded-full'
                    }
                >
                    <Icon
                        name={'users-user'}
                        size={20}
                        color={Colors.PRIMARY}
                    />
                </div>
            ) : (
                <Avatar
                    alt={revieweeFullName}
                    src={revieweeProfilePictureUrl}
                />
            )}

            <RevieweeInformation
                revieweeFullName={revieweeFullName}
                revieweeJobTitle={revieweeJobTitle}
            />

            <Pills
                className={'shrink-0'}
                variant={'primary'}
            >
                {pillLabel}
            </Pills>
        </div>
    );
};
